import { gql } from '__generated__';

export default gql(`
  mutation AddTicketCategory($input: AddTicketCategoryInput!) {
    addTicketCategory(input: $input) {
      id
    }
  }
`);
